import type { ItemMaterial, ProductPublicDto } from "@sticker-giant/sg-frontend-common";

export function getMaterialBounds(product: ProductPublicDto, material: ItemMaterial) {
  const option = product.materialOptions.find(m => m.sku === material);
  if (!option) return null;

  return {
    minWidth: option.minWidth,
    minHeight: option.minHeight,
    maxWidth: option.maxWidth,
    maxHeight: option.maxHeight,
  };
}
